import angular from 'angular';
import scenes from './scenes';

export default angular.module('scenes.loanVariations', [scenes]).name;
